import moment from "moment";

const timestampToStringMiddleware = () => (next) => (action) => {
  const { attributes = {} } = action;
  const { start_on, due_on } = attributes;

  if (typeof start_on === `number`) {
    action.attributes.start_on = moment.unix(start_on).utc().format(`YYYY-MM-DD`);
  }

  if (typeof due_on === `number`) {
    action.attributes.due_on = moment.unix(due_on).utc().format(`YYYY-MM-DD`);
  }

  return next(action);
};

export default timestampToStringMiddleware;
